let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3Ha0P"), load("1PFZq")]).then(() => parcelRequire('31yzi'));